// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"538":"recorder","983":"profiler"}[chunkId] + "." + chunkId + "." + {"538":"9365f8daa11290e97aad","983":"919b8528301e703b85b3"}[chunkId] + ".js";
};